import { render } from "./FrontDeskSettings.vue?vue&type=template&id=217ab0a7"
import script from "./FrontDeskSettings.vue?vue&type=script&lang=js"
export * from "./FrontDeskSettings.vue?vue&type=script&lang=js"

import "./FrontDeskSettings.vue?vue&type=style&index=0&id=217ab0a7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__